export default __webpack_public_path__ + "static/media/manutencao.8f11f241.svg";